import { render, staticRenderFns } from "./wowShare.vue?vue&type=template&id=17a8038a&scoped=true&"
import script from "./wowShare.vue?vue&type=script&lang=js&"
export * from "./wowShare.vue?vue&type=script&lang=js&"
import style0 from "./wowShare.vue?vue&type=style&index=0&id=17a8038a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8038a",
  null
  
)

export default component.exports